import { Button } from "rebass";
import styled from "styled-components";

export const SubmitButton = styled(Button)`
  color: #fff;
  background-color: ${({ theme: { colors } }) => colors["sp-blue"]};

  text-transform: uppercase;
  transition: all .4s;
  letter-spacing: .5px;
  &:disabled {
    background-color: ${({ theme: { colors } }) => colors["hoki"]};
  }
`;

SubmitButton.defaultProps = {
  type: "submit",
  as: "button",
  width: [1],
  px: ["26px"],
  py: ["15px"],
  borderRadius: "5px",
};
